import React, { useMemo } from 'react'
import { Box, Button, Grid, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from '@material-ui/core'
import ClientProfilesView from '../../components/ClientProfilesView'
import { DefaultClientProfiles } from '../../constants'
import { DataGrid } from '@material-ui/data-grid'
import { useQuery } from 'react-query'
import { ClientAPI } from '../../utils/api'
import { useHistory, useParams } from 'react-router'
import moment from 'moment'
const ClientDetails = () => {
    const { clientId } = useParams<{ clientId: string }>()
    const { data } = useQuery(['getclientdetails', clientId], () => ClientAPI.getDetail(+clientId))
    const history = useHistory()
    const profiles = useMemo(() => {
        if (data && data.profiles) {
            return data.profiles
        }
        return DefaultClientProfiles
    }, [data])

    const initialInterviews = useMemo(() => {
        if (data && data.initialInterviews) {
            return data.initialInterviews
        }
        return []
    }, [data])

    return <Box>
        <ClientProfilesView hideDetailButtton profiles={profiles} />
        <Box mt={2}>
            <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                    <Paper>
                        <Box p={2}>
                            <Typography>首次约谈记录</Typography>
                            <Box>
                                <Table>
                                    <TableHead>
                                        <TableCell>创建时间</TableCell>
                                        <TableCell>状态</TableCell>
                                        <TableCell>操作</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {initialInterviews.map(interview => <TableRow>
                                            <TableCell>{moment(interview.create_time).format('YYYY-MM-DD HH:mm')}</TableCell>
                                            <TableCell>{interview.status === 'finish' ? '已完成' : '未完成'}</TableCell>
                                            <TableCell><Button onClick={()=> history.push(`/coach/client/${interview.client_id}/initialinterview/${interview.id}`)} variant="text" size="small">查看详情</Button></TableCell>
                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Paper>
                        <Box p={2}>
                            <Typography>一对一教练记录</Typography>
                            <Box>
                                <Table>
                                    <TableHead>
                                        <TableCell>创建时间</TableCell>
                                        <TableCell>教练进度</TableCell>
                                        <TableCell>状态</TableCell>
                                        <TableCell>操作</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {data?.coachings.map(c => <TableRow>
                                            <TableCell>{moment(c.create_time).format('YYYY-MM-DD HH:mm')}</TableCell>
                                            <TableCell>{`${c.currentLevel}/${c.number_of_times}`}</TableCell>
                                            <TableCell>{c.status === 'finish' ? '已完成' : (c.goals ? '进行中': '未开始')}</TableCell>
                                            <TableCell><Button onClick={()=> history.push(`/coach/client/${c.client_id}/coaching/${c.id}/history`)} variant="text" size="small">查看详情</Button></TableCell>
                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Paper>
                        <Box p={2}>
                            <Typography>团体教练记录</Typography>
                            <Box>
                                <Table>
                                    <TableHead>
                                        <TableCell>类型</TableCell>
                                        <TableCell>购买时间</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {data?.groupCoacningOrders.map(c => <TableRow>
                                            <TableCell>{c.title}</TableCell>
                                            <TableCell>{moment(c.finish_time).format('YYYY-MM-DD HH:mm')}</TableCell>

                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Paper>
                        <Box p={2}>
                            <Typography>参加过的训练营</Typography>
                            <Box>
                                <Table>
                                    <TableHead>
                                        <TableCell>名称</TableCell>
                                        <TableCell>报名时间</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {data?.coachCamps.map(c => <TableRow>
                                            <TableCell>{c.name}</TableCell>
                                            <TableCell>{moment(c.enrollment.create_time).format('YYYY-MM-DD HH:mm')}</TableCell>
                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Paper>
                        <Box p={2}>
                            <Typography>学习过的课程</Typography>
                            <Box pt={2}>
                                {data?.courses.map(c=> <Box pt={1} pb={1}>
                                    {c.name}
                                </Box>)}
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    </Box>
}

export default ClientDetails